import { styled } from '@linaria/react';

import { isAutohide, type OffersSlimVariant } from '../../../utils/variants';

type CtaProps = { ctaLabel: string; variant?: OffersSlimVariant };

const Cta = styled.div<CtaProps>`
  & > button {
    background-color: var(--offer-cta-bg-color);
    border-radius: var(--offer-cta-border-radius);
    color: var(--offer-cta-color);
    line-height: var(--base-line-height);
    padding: var(--offer-cta-padding);

    border: 0;
    font-size: 1em; /* 16px */
    font-weight: 600;
    margin: 0.5em 0 0.5em; /* 8px */
    transition:
      background-color 0.25s ease-out,
      color 0.25s ease-out;
    width: 100%;
    cursor: pointer;
    display: block;
    text-align: center;
    text-decoration: none;

    & > span {
      display: ${p => (isAutohide(p) ? 'initial' : 'none')};
    }

    &::before {
      content: ${p => (isAutohide(p) ? 'initial' : `'${p.ctaLabel}'`)};
      padding: 4px;
    }

    &:not(:disabled):hover {
      background-color: var(--offer-cta-bg-color-hover);
    }
  }
`;

export default Cta;
